import { createContext } from 'react';

import { BoardContentDetail } from '@/types/boardContent';

interface BoardContentContextType {
  data: BoardContentDetail;
}

const BoardContentContext = createContext<BoardContentContextType>({
  data: {} as BoardContentDetail,
});

export default BoardContentContext;
